import React, { useState, useEffect, useRef } from "react";

/**
 *
 * @param {string} labelName
 * @param {string} type
 * @param {string} name
 * @param {string} value
 * @param {string} placeholder
 * @param {boolean} isRequired
 * @param {string} incorrectValueText
 * @param {string} classe
 * @param {function} onChange
 * @param {Element} icon
 */
const InputText = (props) => {
  const {
    labelName,
    type,
    name,
    value,
    min,
    max,
    id,
    placeholder,
    isRequired,
    incorrectValueText,
    classe,
    onChange,
    icon,
  } = props;

  return (
    <label className={`${classe} block`} htmlFor={name}>
      <span
        className={`${
          isRequired && "after:ml-0.5 after:text-primary after:content-['*']"
        } block text-left font-nunito text-xs font-thin text-black/70`}
      >
        {labelName}
      </span>
      <input
        autoComplete="off"
        type={type}
        name={name}
        id={id}
        max={max && Number(max)}
        min={min && Number(min)}
        value={value}
        placeholder={placeholder}
        pattern={type === "tel" && "[0-9]{3}-[0-9]{3}-[0-9]{4}"}
        onChange={(e) => onChange(e)}
        className={`animate bg-gray-50 placeholder:text-back/70 text-gray-700 peer mt-0.5 w-full rounded border border-secondary px-2 py-1.5 text-xs text-black/70 placeholder:text-xs focus:border-primary focus:outline-none md:py-2  md:text-xs`}
      />
      <p className="invisible mt-1 text-left text-xs text-primary peer-invalid:visible">
        {incorrectValueText}
      </p>
    </label>
  );
};

export default InputText;
